import React from "react";
import classnames from "classnames";

export class OptionButton extends React.PureComponent {
  state = {
    value: {},
  };
  listToMap(list) {
    const map = {};
    if (list) {
      for (const item of list) {
        map[item] = true;
      }
    }
    return map;
  }
  mapToList(map) {
    return this.props.options
      .filter(option => map[option.slug])
      .map(option => option.slug);
  }
  selectOption(slug) {
    if (this.props.multi) {
      const value = Object.assign({}, this.state.value);
      if (value[slug]) {
        delete value[slug];
      } else {
        value[slug] = true;
      }
      this.props.onChangeValue(this.mapToList(value));
      this.setState({ value });
    } else {
      this.props.onChangeValue(slug);
      this.setState({ value: slug });
    }
  }
  getState(props) {
    if (this.props.multi) {
      return {
        value: this.listToMap(props.value),
      };
    } else {
      return {
        value: props.value,
      };
    }
  }
  isSelected(option) {
    if (this.props.multi) {
      return this.state.value[option.slug];
    } else {
      return this.state.value === option.slug;
    }
  }
  constructor(props) {
    super(props);
    this.state = this.getState(props);
  }
  componentWillReceiveProps(newProps) {
    this.setState(this.getState(newProps));
  }
  render() {
    return (
      <div className="optionButtons">
        {this.props.options.map(option => (
          <div
            className={classnames(
              "optionButtonItem",
              this.isSelected(option) && "active",
              option.shrink && "shrink",
            )}
            onClick={() => this.selectOption(option.slug)}
            key={option.slug}
            style={{ display: this.props.setsubiFlg && !this.props.setsubiAvailableFlg && option.slug != 'access' ? 'none' : '' }}
          >
            {option.name}
          </div>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./common/OptionButton.jsx